import React, { useEffect, useState } from 'react'
import compose from 'lodash/flowRight'
import { injectIntl } from 'react-intl'
import queryString from 'query-string'
import axios from 'axios'
import { withRouter } from 'react-router-dom'

import { Layout, Components } from '@kyndio/kynd-shared-components'

import * as constants from 'kynd_constants'
import FormStep1 from '../FormStep1'
import FormStep2 from '../FormStep2'

import {
  Container
} from './styles'

const LandingPage = (props) => {
  const [exerciseState, setExerciseState] = useState(
    {
      status: constants.STATUS.INVITED,
      mode: constants.MODE.DEFAULT,
      loading: false,
      representative: {
        prefilled: false,
        code: '',
        name: '',
        email: '',
        orgName: '',
        domain: '',
        username: '',
        terms: false,
        errors: {
          email: false,
          username: false,
          code: false,
          name: false,
          orgName: false,
          terms: false,
          wrongCode: false
        }
      },
      recipients: new Array(25).fill({ error: false, username: '' }),
      formError: false,
      modalVisibility: false,
      recipientsToAdd: []
    }
  )

  useEffect(() => {
    const { data } = queryString.parse(props.location.search)

    if (data) {
      const delimiter = '<|?'
      const queryParams = Buffer.from(data, 'base64').toString().split(delimiter)
      const code = queryParams[0]
      let email
      let domain
      let orgName

      if (queryParams.length > 2) {
        [, domain, orgName] = queryParams
      } else {
        [, email] = queryParams
        // eslint-disable-next-line prefer-destructuring
        domain = email.split('@')[1]
      }

      setExerciseState((prevState) => ({
        ...prevState,
        representative: {
          ...prevState.representative,
          prefilled: true,
          code: code || '',
          email: email || '',
          domain: domain || '',
          orgName: orgName || ''
        }
      }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (exerciseState.representative.prefilled && !exerciseState.endpoint) {
      getEndpoint()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exerciseState.representative.code, exerciseState.representative.domain])

  const getEndpoint = async () => {
    const { domain, email, code } = exerciseState.representative
    const orgDomain = domain || email.split('@')[1]

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/phishing-simulation?code=${code}&domain=${orgDomain}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          }
        }
      )

      if (res.status === 204) {
        return setExerciseState((prevState) => ({ ...prevState, endpoint: res.headers.link.substring(0, res.headers.link.indexOf(';')), representative: { ...prevState.representative, errors: { ...prevState.representative.errors, wrongCode: false } } }))
      }
    } catch (error) {
      return setExerciseState((prevState) => ({ ...prevState, representative: { ...prevState.representative, errors: { ...prevState.representative.errors, wrongCode: true } } }))
    }
  }

  const validateRepresentativeRequiredFields = () => {
    let isValid = true
    const items = [exerciseState.representative.prefilled ? 'username' : 'email', 'code', 'name', 'orgName', 'terms']

    items.forEach((val) => {
      if (!exerciseState.representative[val]) {
        setExerciseState((prevState) => ({ ...prevState, representative: { ...prevState.representative, errors: { ...prevState.representative.errors, [val]: true } } }))
        isValid = false
      }
    })

    return isValid
  }

  const handleTermsModalChange = (value) => {
    setExerciseState((prevState) => ({ ...prevState, representative: { ...prevState.representative, terms: !value, errors: { ...prevState.representative.errors, terms: value } } }))
  }

  const handleRepresentativeChanges = (e, { name, value }) => {
    setExerciseState((prevState) => (
      {
        ...prevState,
        representative: {
          ...prevState.representative,
          [name]: name === 'terms' ? !prevState.representative.terms : value,
          errors: {
            ...prevState.representative.errors, [name]: name === 'terms' ? prevState.representative.terms : !value
          }
        },
        formError: false
      }
    )
    )

    if (name === 'username') {
      setExerciseState((prevState) => ({ ...prevState, representative: { ...prevState.representative, email: `${value}@${prevState.representative.domain}` } }))
    }

    if (name === 'email') {
      setExerciseState((prevState) => ({ ...prevState, representative: { ...prevState.representative, domain: prevState.representative.email.split('@')[1] } }))
    }
  }

  const handleRepresentativeBlur = async () => {
    const { endpoint, representative } = exerciseState

    if (representative.code && representative.email) {
      if (!endpoint) {
        await getEndpoint()
      }
    }
  }

  const handleOnStep1MainAction = async () => {
    const { representative, endpoint } = exerciseState

    if (validateRepresentativeRequiredFields()) {
      setExerciseState((prevState) => ({ ...prevState, loading: true }))
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}${endpoint}/representative-details`,
          { email: representative.email, name: representative.name, companyName: representative.orgName },
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'x-kynd-phish-sim-code': representative.code,
              'x-kynd-phish-sim-email': representative.email
            }
          }
        )

        setExerciseState((prevState) => ({ ...prevState, loading: false, status: constants.STATUS.ACCEPTED }))
      } catch (error) {
        if (error.response.status === 409) {
          try {
            const { data } = await axios.get(
              `${process.env.REACT_APP_API_URL}${endpoint}`,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Access-Control-Allow-Origin': '*',
                  'x-kynd-phish-sim-code': representative.code,
                  'x-kynd-phish-sim-email': representative.email
                }
              }
            )

            const rest = new Array(25 - data.recipients.length).fill({ error: false, username: '' })

            return setExerciseState((prevState) => ({ ...prevState, loading: false, status: data.status, recipients: [...data.recipients, ...rest] }))
          } catch (error) {
            setExerciseState((prevState) => ({ ...prevState, loading: false, formError: true }))
          }
        }

        setExerciseState((prevState) => ({ ...prevState, loading: false, formError: true }))
      }
    }
  }

  return (
    <Container>
      <Layout.FormPageLayout
        pulse
        FormContent={
        exerciseState.status === constants.STATUS.INVITED
          ? <FormStep1
              loading={exerciseState.loading}
              disabled={!exerciseState.endpoint}
              prefilled={exerciseState.representative.prefilled}
              email={exerciseState.representative.email}
              domain={exerciseState.representative.domain}
              username={exerciseState.representative.username}
              code={exerciseState.representative.code}
              name={exerciseState.representative.name}
              orgName={exerciseState.representative.orgName}
              terms={exerciseState.representative.terms}
              errors={exerciseState.representative.errors}
              formError={exerciseState.formError}
              onHandleTermsModalChange={handleTermsModalChange}
              onChange={handleRepresentativeChanges}
              onBlur={handleRepresentativeBlur}
              onMainAction={handleOnStep1MainAction}
              {...props}
          />
          : <FormStep2
              loading={exerciseState.loading}
              disabled={exerciseState.status === constants.STATUS.STARTED && exerciseState.mode === constants.MODE.DEFAULT && exerciseState.recipients.filter((item) => item.email).length === exerciseState.recipients.length}
              status={exerciseState.status}
              mode={exerciseState.mode}
              domain={exerciseState.representative.domain}
              orgName={exerciseState.representative.orgName}
              recipients={exerciseState.recipients}
              modalVisibility={exerciseState.modalVisibility}
              representative={exerciseState.representative}
              recipientsToAdd={exerciseState.recipientsToAdd}
              setExerciseState={setExerciseState}
              endpoint={exerciseState.endpoint}
              {...props}
          />
      }
        InfoContent={
          <>
            <Components.InfoTitle>
              {
            props.intl.messages[`phishing_tool_info_title_${exerciseState.status.toLowerCase()}_${exerciseState.mode.toLowerCase()}`]
              ? props.intl.formatMessage({ id: `phishing_tool_info_title_${exerciseState.status.toLowerCase()}_${exerciseState.mode.toLowerCase()}` })
              : props.intl.formatMessage({ id: `phishing_tool_info_title_${exerciseState.status.toLowerCase()}` })
          }

            </Components.InfoTitle>
            <Components.InfoContent>
              {
            props.intl.messages[`phishing_tool_info_content_${exerciseState.status.toLowerCase()}_${exerciseState.mode.toLowerCase()}`]
              ? props.intl.formatMessage({ id: `phishing_tool_info_content_${exerciseState.status.toLowerCase()}_${exerciseState.mode.toLowerCase()}` })
              : props.intl.formatMessage({ id: `phishing_tool_info_content_${exerciseState.status.toLowerCase()}` })
          }
            </Components.InfoContent>
          </>
    }
      />
    </Container>
  )
}

export default compose(withRouter, injectIntl)(LandingPage)
